module.exports = __webpack_public_path__ + "img/14pts01267.777fd25b.png";